import { Fragment, useCallback, useMemo, useState } from 'react';
import { get } from 'lodash';
import {
  Divider,
  InputDescription,
  InputTitle,
} from 'components/atoms/styleds';
import Input from 'components/atoms/Input';
import { CreateLink } from 'components/molecules/user/MenuItem/styled';
import RestaurantsApi from 'libs/api/restaurants';
import { getErrorByKey } from '../../../../utils';

const restaurantsApi = new RestaurantsApi();

const getTexts = (variant) => {
  switch (variant) {
    case 'fixed':
      return {
        title: 'Hai impostato Fisso',
        description:
          'Ora inserisci il valore espresso in euro da applicare al servizio delivery.',
        twoInputs: false,
      };
    case 'per_kilometer':
      return {
        title: 'Hai impostato Costo al chilometro',
        description:
          'Ora inserisci il valore espresso in euro da applicare al servizio delivery.',
        twoInputs: false,
      };
    case 'fixed_or_per_kilometer':
      return {
        title: 'Hai impostato Fisso o costo al chilometro',
        description:
          'Ora inserisci il valore espresso in euro da applicare al servizio delivery.',
        twoInputs: true,
      };
    case 'fixed_plus_fixed':
      return {
        title: 'Hai impostato Fisso + fisso',
        description:
          'Ora inserisci il valore espresso in euro da applicare al servizio delivery.',
        twoInputs: true,
      };
    default:
      return {
        title: '',
        description: '',
        twoInputs: false,
      };
  }
};

export const CostRelationView = ({ data, onChange }) => {
  const { title, description, twoInputs } = getTexts(data.delivery_cost_type);
  return (
    <div style={{ marginTop: 8, marginBottom: 40 }}>
      <InputTitle>{title}</InputTitle>
      <InputDescription>{description}</InputDescription>
      <Input
        name='delivery_cost_1'
        label='Valore in € per area 1'
        value={data.delivery_cost_1}
        onChange={onChange}
      />
      {twoInputs && (
        <Input
          name='delivery_cost_2'
          label='Valore in € per area 2'
          value={data.delivery_cost_2}
          onChange={onChange}
        />
      )}
    </div>
  );
};

const ZoneItem = ({ i, index, errorByKeys, onChange, onDelete }) => {
  const [localCityValue, setLocalCityValue] = useState(
    i.delivery_zip_attributes.city || '',
  );

  const localOnChangeCity = useCallback(
    (e) => {
      onChange(e, i.uuid);
      setLocalCityValue(e?.target?.value);
    },
    [onChange, i],
  );

  const onBlur = useCallback(async () => {
    try {
      const { data } = await restaurantsApi.get('delivery_zip', {
        params: {
          city: localCityValue,
        },
      });
      if (data.delivery_zips) {
        const [firstItem] = data.delivery_zips;
        if (firstItem) {
          onChange(
            { target: { name: `cap_${index}`, value: firstItem.cap } },
            i.uuid,
          );
        }
      }
    } catch (e) {}
  }, [onChange, localCityValue]);

  return (
    <Fragment>
      <Input
        onChange={localOnChangeCity}
        label='Inserisci il comune'
        name={`city_${index}`}
        value={i.delivery_zip_attributes.city}
        deleteIcon={true}
        style={{ display: 'flex' }}
        onBlur={onBlur}
        onClickDelete={() => onDelete(i, index)}
      />
      <InputDescription mt={0}>Aggiungi comune e CAP</InputDescription>
      <Input
        onChange={(e) => onChange(e, i.uuid)}
        label='Inserisci il cap'
        name={`cap_${index}`}
        value={i.delivery_zip_attributes.cap}
        error={errorByKeys[i.delivery_zip_attributes.cap]}
        style={{ display: 'flex' }}
        deleteIcon={true}
        onClickDelete={() => onDelete(i, index)}
      />
      <Divider mb={20} />
    </Fragment>
  );
  // return (
  //   <Fragment key={index.toString()}>
  //     <Input
  //       onChange={(e) => onChange(e, i.uuid)}
  //       label='Inserisci il comune'
  //       name={`city_${index}`}
  //       value={i.delivery_zip_attributes.city}
  //       deleteIcon={true}
  //       onClickDelete={() => onDelete(i, index)}
  //     />
  //     <InputDescription mt={0}>Aggiungi comune e CAP</InputDescription>
  //     <Input
  //       onChange={(e) => onChange(e, i.uuid)}
  //       label='Inserisci il cap'
  //       name={`cap_${index}`}
  //       value={i.delivery_zip_attributes.cap}
  //       error={errorByKeys[i.delivery_zip_attributes.cap]}
  //       deleteIcon={true}
  //       onClickDelete={() => onDelete(i, index)}
  //     />
  //   </Fragment>
  // );
};

export const ZoneMunicipality = ({
  onChange,
  onDelete,
  items,
  onClickCreate,
  hideSecondZone = false,
  errors,
}) => {
  const errorByKeys = useMemo(() => {
    const err = {};
    const deliveryErrors = get(
      errors,
      'delivery_zips_restaurants.delivery_zip',
      {},
    );
    deliveryErrors &&
      Object.keys(deliveryErrors)?.forEach((key) => {
        deliveryErrors[key] &&
          Object.keys(deliveryErrors[key]).forEach((errorField) => {
            err[errorField] = deliveryErrors[key][errorField];
          });
      });
    return err;
  }, [errors]);

  const firstZone = useMemo(() => {
    const zones = [];
    items?.forEach((i) => {
      if (i.zone === 'first_zone' && !i._destroy) {
        zones.push(i);
      }
    });
    return zones;
  }, [items]);

  const secondZone = useMemo(() => {
    const zones = [];
    items?.forEach((i) => {
      if (i.zone === 'second_zone' && !i._destroy) {
        zones.push(i);
      }
    });
    return zones;
  }, [items]);

  return (
    <div style={{ marginTop: 8, marginBottom: 40 }}>
      <InputTitle>Hai selezionato Comune/i</InputTitle>
      <InputDescription>
        Ora inserisci i comuni in cui effettuerai il servizio di delivery.
      </InputDescription>
      <InputDescription mt={0}>Indica il comune dell’area 1.</InputDescription>
      {firstZone?.map((i, index) => {
        return (
          <ZoneItem
            index={index}
            key={index.toString()}
            errorByKeys={errorByKeys}
            i={i}
            onChange={onChange}
            onDelete={onDelete}
          />
        );
      })}
      <CreateLink
        as='span'
        style={{ paddingRight: 0, paddingBottom: 20 }}
        role='presentation'
        onClick={() => onClickCreate('zipCode', 'first_zone')}
      >
        + Aggiungi CAP & Comune
      </CreateLink>
      {!hideSecondZone && (
        <>
          <InputDescription mt={0}>
            Indica i comuni dell’area 2.
          </InputDescription>
          {secondZone?.map((i, index) => {
            return (
              <ZoneItem
                key={index.toString()}
                errorByKeys={errorByKeys}
                i={i}
                index={index}
                onChange={onChange}
                onDelete={onDelete}
              />
            );
          })}
          <CreateLink
            as='span'
            style={{ paddingRight: 0 }}
            role='presentation'
            onClick={() => onClickCreate('zipCode', 'second_zone')}
          >
            + Aggiungi CAP & Comune
          </CreateLink>
        </>
      )}

      {/*{ items?.map((i, index) => {
        return (
          <Fragment key={index.toString()}>
            <Input
              onChange={(e) => onChange(e, index)}
              label='Nome comune'
              name={`city_${index}`}
              value={i.city}
              deleteIcon={true}
              onClickDelete={() => onDelete(i, index)}
            />
            <InputDescription mt={0}>
              Inserisci i CAP per la città di Bergamo
            </InputDescription>
            <Input
              onChange={(e) => onChange(e, index)}
              label='CAP'
              name={`cap_${index}`}
              value={i.cap}
              deleteIcon={true}
              onClickDelete={() => onDelete(i, index)}
            />
          </Fragment>
        );
      }) }*/}
    </div>
  );
};

export const ZoneRadius = ({ data, onChange }) => {
  const showSecondArea =
    data?.delivery_cost_type !== 'fixed' &&
    data?.delivery_cost_type !== 'per_kilometer';

  return (
    <div style={{ marginTop: 8, marginBottom: 40 }}>
      <InputTitle>Hai selezionato Raggio</InputTitle>
      <InputDescription>
        Imposta il raggio, espresso in km, entro il quale effettuerai il
        servizio di delivery.
      </InputDescription>
      <InputDescription mt={0}>
        Indica il raggio che delimita l’area 1.
      </InputDescription>
      <Input
        name='first_radius'
        label='Area inclusa nell’area 1'
        value={data.first_radius}
        onChange={onChange}
        type='number'
      />
      {showSecondArea && (
        <>
          <InputDescription mt={0}>
            Indica il raggio che delimita l’area 2.
          </InputDescription>
          <Input
            name='second_radius'
            label='Area inclusa nell’area 2'
            value={data.second_radius}
            onChange={onChange}
            type='number'
          />
        </>
      )}
    </div>
  );
};
